import { SidePanelContent } from '~/components/sidepanel-section';
import { P2GBox, P2GButton, P2GContainer, P2GText } from '@parcel2go/core-ui';
import { Integration } from '~/lib/api/account-linking/types';
import { OnboardingTitle } from '../rules/onboarding-title';
import { OnboardingActionBar } from '../intro/onboarding-action-bar';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';
import { AppSurface } from '~/components/surface/app-surface';
import { OnboardingScreenContentWrapper } from '../../OnboardingScreenContentWrapper';

type props = {
  isXs: boolean;
  integration: Integration;
  onDone: () => void;
};

const CsvMessage = () => <>We’ve imported your CSV. Your orders will be visible in Smart Send and ready to ship.</>;

const Message = ({ integration }: { integration: Integration | null }) => (
  <>We’ll import your unfulfilled sales from {integration.name} and update them with tracking details when you ship.</>
);

const JustLinkedScreen = ({ isXs, integration, onDone }: props) => {
  const isCsv = integration.slug === 'csv';
  return (
    <>
      <OnboardingScreenContentWrapper>
        <P2GBox textAlign="center">
          <SidePanelContent>
            <OnboardingTitle
              text={
                isCsv
                  ? 'Orders added from your <span>{{integration}}</span>'
                  : "You've linked with <span>{{integration}}</span>"
              }
              translationKey="SETUP_SALES_CHANNELS_CONNECTED_TITLE"
              values={{ integration: integration.name }}
            />
            {isCsv ? (
              <P2GText variant="subtitle1" component="div">
                CSV uploaded successfully!
              </P2GText>
            ) : (
              <P2GText variant="subtitle1" component="div">
                {integration.name} linked successfully!
              </P2GText>
            )}
          </SidePanelContent>
        </P2GBox>
        <P2GContainer maxWidth="sm">
          <P2GBox mt={4}>
            <ECommerceLogo integration={integration.slug} style={{ height: '70px', maxWidth: '100%' }} />
          </P2GBox>
          <P2GBox mt={4}>
            <AppSurface>
              <P2GText>{isCsv ? <CsvMessage /> : <Message integration={integration} />}</P2GText>
              <P2GBox mt={2}>
                <P2GButton onClick={onDone} variant="primary" size="large">
                  Continue
                </P2GButton>
              </P2GBox>
            </AppSurface>
          </P2GBox>
          {isXs && (
            <P2GBox mt={2}>
              <AppSurface>
                <P2GBox textAlign="center">
                  <CsvMessage />
                </P2GBox>
              </AppSurface>
            </P2GBox>
          )}
        </P2GContainer>
      </OnboardingScreenContentWrapper>
      <OnboardingActionBar
        next={
          <P2GButton size="large" onClick={onDone} variant="primary" style={{ minWidth: 'unset' }}>
            Continue
          </P2GButton>
        }
      >
        {!isXs && (
          <P2GText variant="subtitle2">{isCsv ? <CsvMessage /> : <Message integration={integration} />}</P2GText>
        )}
      </OnboardingActionBar>
    </>
  );
};

export default JustLinkedScreen;
